import { Modal, Trigger, Content, Title, Description, Close, Footer } from './components';

import type { ModalProps } from './components/modal.component';
import type { TriggerProps } from './components/trigger.component';
import type { ContentProps } from './components/content.component';
import type { TitleProps } from './components/title.component';
import type { DescriptionProps } from './components/description.component';
import type { CloseProps } from './components/close.component';
import type { FooterProps } from './components/footer.component';

import Primitive from './primitives';

type ModalType = typeof Modal & {
  Root: typeof Modal;
  Trigger: typeof Trigger;
  Content: typeof Content;
  Title: typeof Title;
  Description: typeof Description;
};

const ModalComponent: ModalType = Object.assign(Modal, {
  Root: Modal,
  Trigger,
  Content,
  Title,
  Description,
  Close,
  Footer,
  Primitive,
});

export {
  ModalComponent as Modal,
  Modal as ModalRoot,
  Trigger as ModalTrigger,
  Content as ModalContent,
  Title as ModalTitle,
  Description as ModalDescription,
  Close as ModalClose,
  Footer as ModalFooter,
};

export type { ModalProps, TriggerProps, ContentProps, TitleProps, DescriptionProps, CloseProps, FooterProps };
